import { RevenueReportAccessLogListPage } from "@/features/revenue-report-access-log/pages/RevenueReportAccessLogListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-report-access-log/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_access_log.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportAccessLogListPage,
});
